<template>
  <el-dialog
    title=""
    :visible.sync="visible"
    destroy-on-close
    :show-close="false"
    width="300px"
    custom-class="bindWx__dialog onboarding__dialog"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <div class="bindWx__dialog__header">
      <span class="close" @click="closeClick">
        <svg-icon iconClass="circleClose"></svg-icon>
      </span>
    </div>
    <div class="bindWx__dialog__container">
      <div class="bindWx__dialog__container__qrcode" v-if="type == 'login' ? info : wechat_bind_qrcode_url">
        <vue-qrcode :value="type == 'login' ? info.url : wechat_bind_qrcode_url" class="qrcode" :width="240" />
        <img src="android-chrome-192x192.png" alt="" class="logo" />
      </div>
      <p>{{ type == 'login' ? $t('bindWechatDialog.tip.login') : $t('bindWechatDialog.tip.bindWx') }}</p>
    </div>
  </el-dialog>
</template>
<script>
import VueQrcode from 'vue-qrcode'
export default {
  name: 'BindWxDialog',
  components: {
    VueQrcode,
  },
  props: {
    type: {
      type: String,
      default: 'login',
    },
  },
  computed: {
    visible() {
      return this.$store.getters['wxLogin/show']
    },
    info() {
      return this.$store.getters['wxLogin/info']
    },
    loading() {
      return this.$store.getters['wxLogin/loading']
    },
    wechat_bind_qrcode_url() {
      return this.$store.getters['thirdParty/qrcode']
    },
  },
  methods: {
    closeClick() {
      this.$store.dispatch('wxLogin/hide')
      this.$store.dispatch('thirdParty/clearInterval')
      this.$emit('close')
    },
  },
}
</script>
<style lang="scss">
div.bindWx__dialog {
  border-radius: 12px !important;
  &__header {
    color: rgba(0, 0, 0, 0.8);
    .close {
      position: absolute;
      top: -18px;
      right: -18px;
      cursor: pointer;

      .svg-icon {
        width: 36px !important;
        height: 36px !important;
        color: unset !important;
      }
    }
  }
  &__container {
    text-align: center;
    //padding: 30px;
    &__qrcode {
      position: relative;
      border-radius: 6px;
      overflow: hidden;
      .logo {
        width: 50px;
        height: 50px;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        border-radius: 6px;
        border: 2px solid #fff;
        background: #fff;
        overflow: hidden;
      }
    }
    p {
      margin-top: 15px;
      font-size: 14px;
      color: #454545;
    }
  }
}
</style>
